import { useEffect, useRef, useState } from "react";

interface ISearchPanel extends React.HTMLProps<HTMLDivElement> {
  onSearch: (query: string) => Promise<any>;
  onChangeQuery: (newValue: string) => any;
  baseValue: string;
}
export const SearchPanel = ({
  onSearch,
  onChangeQuery,
  baseValue,
  ...props
}: ISearchPanel) => {
  const [query, setQuery] = useState<string>(baseValue);
  const [formIsSending, setFormIsSending] = useState(false);

  const onSearchButtonClick = () => {
    if (query == "") {
      searchField.current?.focus();
    } else if (submitButton) {
      submitButton.current?.click();
    }
  };

  const onSumbit = async (e: any) => {
    e.preventDefault();
    if (formIsSending) return false;
    setFormIsSending(true);
    await onSearch(query);
    setFormIsSending(false);
  };
  const form = useRef<HTMLFormElement>(null);
  const searchField = useRef<HTMLInputElement>(null);

  const submitButton = useRef<HTMLButtonElement>(null);

  return (
    <div className="base-page-element d-flex" {...props}>
      <form
        action=""
        style={{ position: "relative" }}
        onSubmit={onSumbit}
        ref={form}
        className="d-flex w-100"
      >
        <input
          ref={searchField}
          onChange={(e) => {
            setQuery(e.target.value);
          }}
          required
          value={query}
          type="text"
          placeholder="Что вам интересно?"
          className="form-control"
        />
        <div
          onClick={onSearchButtonClick}
          style={{
            position: "absolute",
            right: 4 + "px",
            top: 6 + "px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-search"
            viewBox="0 0 16 16"
          >
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
          </svg>
          <button
            type="submit"
            style={{ visibility: "hidden" }}
            ref={submitButton}
          ></button>
        </div>
      </form>
    </div>
  );
};
